import dayjs from 'dayjs';

// we are setting time to noon as a workaround to avoid issues with timezone
export function normalizeDate(value) {
  const date = dayjs(value);

  return date.isValid() ? date.hour(12).toDate() : null;
}
